<mat-card class="p-0">
  <mat-card-title>
    <div class="card-title-text">
   Conferma
    </div>
  </mat-card-title>
  <mat-card-content>
    <p>Importo {{objdettaglio?.Importo}},00 </p>

    <p><strong>* Se il pagamento è stato effettuato con BONIFICO inserire almeno un codice identificativo del pagamento:
      numero di mandato di pagamento o CRO o TNR. Se il pagamento è stato effettuato con PAYPAL indicare l'intestatario
      del conto e la data del pagamento. Il mancato inserimento dei riferimenti del pagamento comporta la non emissione
      della ricevuta. </strong></p>

    <form [formGroup]='frmInserimento' class='inserimento-form'>
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="full-width">
              <!--<textarea id="Note" name="Note" rows="5" cols="50" matInput></textarea>-->

              <input formControlName="Note" id="Note" matInput
                     placeholder="Note">
            </mat-form-field>
          </div>
        </div>
      </div>

     
  <div mat-dialog-actions>
    <button mat-raised-button color="primary"
            [disabled]="!frmInserimento.valid"
            (click)="btnSalva()"
            cdkFocusInitial>
      Salva
    </button>
    </div>

    </form>
  </mat-card-content>
</mat-card>
<style>

  .inserimento-form {
    min-width: 150px;
    max-width: 720px !important;
    width: 100%;
  }

  /* .full-width {
      width: 100%;
    }*/
</style>

